import React, { useEffect, useState } from 'react'

import { useInstallPrompt } from '../../common/hooks/InstallHook'

import { PALETTE } from '../../common/ThemeConstants';
import InstallButton from '../../common/components/InstallButton'

export default function InstallButtonSection() {
    const [getDeferredPrompt, onDeferredPromptUpdated] = useInstallPrompt()
    const [prompt, setPrompt] = useState(undefined)
    const [isVisible, setIsVisible] = useState(false)

    onDeferredPromptUpdated((e) => {
      setIsVisible(e !== undefined)
      setPrompt(e)
    })


    const handleInstallClick = (e) => {
      // Show the install prompt
      if (prompt === undefined) {
        return
      }
      prompt.prompt()
      // Wait for the user to respond to the prompt
      prompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          setIsVisible(false)
        }
      })
    }

    return (
      <>
      {isVisible && (
        <div className="text-center m-auto d-flex flex-nowrap" style={{width:"fit-content"}}>
        <div className="m-1">
        <InstallButton
          backgroundColor={`
          linear-gradient(217deg, rgb(39, 37, 155, 1), rgb(39, 37, 155, .2) 70.71%),
          linear-gradient(127deg, rgb(225, 105, 25, 1), rgb(255, 105, 25, .2) 70.71%),
          linear-gradient(336deg, rgb(184, 42, 139, 1), rgb(184, 42, 139, .2) 70.71%)
          `}
        backgroundColorHover={`
          linear-gradient(217deg, rgb(39, 37, 155, .7), rgb(39, 37, 155, .0) 70.71%),
          linear-gradient(127deg, rgb(225, 105, 25, .7), rgb(255, 105, 25, .0) 70.71%),
          linear-gradient(336deg, rgb(184, 42, 139, .7), rgb(184, 42, 139, .0) 70.71%)
        `}
          color={PALETTE.WHITE}
          colorHover={PALETTE.LIGHTGRAY}
          text="Windows"
          iconType="windows"
          onClick={handleInstallClick}
        />
        </div>
        <div className="m-1">
        <InstallButton
          backgroundColor={`
          linear-gradient(217deg, rgb(39, 37, 155, 1), rgb(39, 37, 155, .2) 70.71%),
          linear-gradient(127deg, rgb(225, 105, 25, 1), rgb(255, 105, 25, .2) 70.71%),
          linear-gradient(336deg, rgb(184, 42, 139, 1), rgb(184, 42, 139, .2) 70.71%)
          `}
        backgroundColorHover={`
          linear-gradient(217deg, rgb(39, 37, 155, .7), rgb(39, 37, 155, .0) 70.71%),
          linear-gradient(127deg, rgb(225, 105, 25, .7), rgb(255, 105, 25, .0) 70.71%),
          linear-gradient(336deg, rgb(184, 42, 139, .7), rgb(184, 42, 139, .0) 70.71%)
        `}
          color={PALETTE.WHITE}
          colorHover={PALETTE.LIGHTGRAY}
          text="iOS/macOS"
          iconType="apple"
          onClick={handleInstallClick}
        />
        </div>
        <div className="m-1">
        <InstallButton
          backgroundColor={`
            linear-gradient(217deg, rgb(39, 37, 155, 1), rgb(39, 37, 155, .2) 70.71%),
            linear-gradient(127deg, rgb(225, 105, 25, 1), rgb(255, 105, 25, .2) 70.71%),
            linear-gradient(336deg, rgb(184, 42, 139, 1), rgb(184, 42, 139, .2) 70.71%)
            `}
          backgroundColorHover={`
            linear-gradient(217deg, rgb(39, 37, 155, .7), rgb(39, 37, 155, .0) 70.71%),
            linear-gradient(127deg, rgb(225, 105, 25, .7), rgb(255, 105, 25, .0) 70.71%),
            linear-gradient(336deg, rgb(184, 42, 139, .7), rgb(184, 42, 139, .0) 70.71%)
          `}
          color={PALETTE.WHITE}
          colorHover={PALETTE.LIGHTGRAY}
          text="Android"
          iconType="android"
          onClick={handleInstallClick}
        />
        </div>
      </div>
      )}
      </>
    )
}